import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';

import IconCalendar from '@white-label-icon/icon-calendar';

import {
  formatWithLocale,
  DATE_TIME_FORMATS,
} from '@white-label-helper/date-utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'b-ticket-travel-insurance-trip-details',
  props: {
  product: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { proxy } = getCurrentInstance() as any;
const i18n = proxy.$i18n;



const destinationsString = computed((): String => {
  return (props.product && props.product.quoteDetails && props.product.quoteDetails.destination && props.product.quoteDetails.destination.join(', ')) || '';
});

const formatDate = (date: string ) => {
  return formatWithLocale(new Date(date), DATE_TIME_FORMATS.weekday_day_month_year_no_comma, i18n.locale.value);
};

return { __sfc: true,proxy, i18n, props, destinationsString, formatDate, IconCalendar }
}

})